<template>
  <Layout row class="parent-selector" basis="auto" justify-around items-center w-tabs>
    <Flex row items-center px-1>
      <span>Use Workflow defined in 'master' form:</span>
      <Toggle :value="isDefinedInMaster" @update:value="onDefinedInMasterUpdate"> </Toggle>
    </Flex>
    <Flex row items-center px-1>
      <span>Master Form:</span>
      <Select
        class="master-form-selector"
        :matchItemsWidth="false"
        searchable
        :items="parentForms"
        :disabled="!isDefinedInMaster"
        @update:value="onParentFormUpdate"
        :value="selectedForm"
      />
    </Flex>
  </Layout>
</template>

<script>
import Layout from '@wizer/core/components/layout/Layout'
import Toggle from '@wizer/core/components/toggle/Toggle'
import Select from '@wizer/core/components/select/Select'
import Flex from '@wizer/core/components/flex/Flex'

export default {
  name: 'StateParent',

  components: {
    Layout,
    Toggle,
    Flex,
    Select,
  },

  props: {
    parentForms: Array,
    selectedForm: null,
    isDefinedInMaster: null,
  },

  methods: {
    onDefinedInMasterUpdate(value) {
      this.$emit('update:isDefinedInMaster', value)
    },
    onParentFormUpdate(value) {
      this.$emit('update:selectedForm', value)
    },
  },
}
</script>

<style scoped>
.master-form-radio {
  flex-direction: row;
}
.parent-selector {
  @apply text-gray-700 text-xs;
}
</style>
